import { Component } from '@angular/core';
import { AccountItemsCardsComponent } from 'libs/shared/src/lib/component/account-items/account-items-cards.component';

@Component({ standalone: false, selector: 'app-account-items-cards', templateUrl: './account-items-cards.component.html' })
export class CustomAccountItemsCardsComponent extends AccountItemsCardsComponent {}
